const list = {
  path: 'agentMessage',
  component: resolve => require(['@/pages/admin/businessmag/agentMessage'], resolve)
}

export default list
